import { render, staticRenderFns } from "./EditGallery.vue?vue&type=template&id=022054e4&scoped=true&"
import script from "./EditGallery.vue?vue&type=script&lang=js&"
export * from "./EditGallery.vue?vue&type=script&lang=js&"
import style0 from "./EditGallery.vue?vue&type=style&index=0&id=022054e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022054e4",
  null
  
)

export default component.exports